import * as React from 'react';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../sanity';
import { OblisPortableText } from '../../../../../../../../../../../oblisPortableText';

export const ArticleBodyContent = () => {
  const {
    data,
  } = useSanityNewsByUrlId();
  if (data == null) {
    return null;
  }
  return (
    <OblisPortableText
      content={data.content}
    />
  );
};
